import { z } from 'zod';
export const TicketStatusSchema = z.enum(['ACTIVE', 'EXPIRED', 'CANCELED']);
export const TicketSchema = z.object({
    id: z.string(),
    userId: z.string(),
    vehicleId: z.string(),
    zoneId: z.string(),
    startsAt: z.date(),
    endsAt: z.date(),
    status: TicketStatusSchema,
    totalCents: z.number().int().min(0),
    createdAt: z.date(),
});
export const CreateTicketSchema = z.object({
    vehicleId: z.string(),
    parkingId: z.string(),
    minutes: z.number().int().min(15, 'Durée minimum 15 minutes'),
});
export const ExtendTicketSchema = z.object({
    minutes: z.number().int().min(15, 'Durée minimum 15 minutes'),
});
